import { API_URL, handleUnauthorized } from './api';

export type ExportFormat = 'csv' | 'xls';

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Downloads an export from the API. Server-side (unlike a client-side dump) it
 * always reflects the **full** filtered dataset, not just the current page.
 */
export async function downloadExport(
  resource: string,
  params: Record<string, string | undefined>,
  filename: string,
  format: ExportFormat = 'csv',
): Promise<void> {
  const url = new URL(`${API_URL}/admin/${resource}/export`);
  for (const [key, value] of Object.entries(params)) {
    if (value) url.searchParams.set(key, value);
  }
  url.searchParams.set('format', format);

  // Auth is an httpOnly session cookie; send it with the request.
  const response = await fetch(url, { credentials: 'include' });

  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Your session expired. Please sign in again.');
  }

  if (!response.ok) {
    throw new Error(`Export failed (${response.status})`);
  }

  triggerDownload(await response.blob(), `${filename}.${format === 'xls' ? 'xls' : 'csv'}`);
}
